export const options = [
  'This shipment has already moved with someone else',
  'This was quoted as a pricing exercise',
  'This shipment hasn’t moved yet',
  'This rate was not competitive ',
  'Other: ',
]
